(function () {
  'use strict';

  /* ============================================================
     Dreame HK mobile burger menu — v7 (2026-08-23)
     Paste-ready for Varify.io / VWO custom JS, and the same file
     ships as a theme asset on the staging theme.

     v6 changes vs v5 (fixes the "some panels have no title" bug):
     1. STALE KEYS FIXED: the convx-burger-menu linklists were
        renamed in Shopify navigation after v5 shipped
        (掃地機械人→掃地機器人, 無綫吸塵器→吸塵機,
        乾濕洗地機→洗地機, 除濕除蟎器→除濕除蟎機). v5's meta
        lookups missed on those four, so their panels lost the
        tagline, badges, and 配件與工具 label — and the product
        grid sat flush at the panel top. All CATEGORY_META /
        (v7) badges moved to product metafields, maps removed.
     2. TOP PADDING: detail panels get 14px top padding so
        spacing never depends on a tagline existing; tagline /
        limited-banner top margins rebalanced to match.
     3. DEAD LINKS FILTERED: others rows whose url is '#'
        (Pocket（基礎版）, PT60 配件) are no longer rendered.
     4. NEW CONTENT: 無葉空氣循環扇 category meta added; store
        rows (香港旗艦店 etc.) get EN subtitles; 型號比較
        subtitle made generic (it appears in many categories).
     5. 暑假優惠 removed from FOCUS_META (promo ended and the
        item has left the linklist); the fallback tile covers any
        future focus item until meta is added.
     Badges aligned with the desktop mega menu script
     (2026-08-22_ab-desktop-megamenu-v3.js). Campaign-dated
     content to review monthly: FOCUS_META images, tag metafield
     values in admin, FOCUS_HIDDEN list.
     ============================================================ */

  var MOBILE_MAX_WIDTH = 988;

  var FOCUS_HIDDEN = ['送C朗球衣'];

  var FOCUS_META = {
    '每月精選': {
      tag: '港澳爆款',
      tagColor: '#c0392b',
      image: 'https://www.dreametech.com.hk/cdn/shop/files/dafault-product-page-aqua-pocket-uni-33.jpg?v=1755241927&width=800',
      imagePosition: '50% 38%',
      theme: 'light',
      desc: '本月編輯推介・熱賣之選',
      tagline: '本月編輯精選，港澳最熱賣之選'
    }
    // future promo focus items (e.g. a new sale) render via the gradient-tile
    // fallback until an entry with image/tag/desc is added here
  };

  // keys are the LIVE linklist titles. NOTE (2026-08-23): the 'subtitle'
  // values below are NO LONGER READ - row subtitles come from the collection
  // metafield custom.burger_menu_subtitle. Map still supplies background /
  // tagline / othersLabel.
  var CATEGORY_META = {
    '掃地機器人': {
      subtitle: 'Robot vacuum',
      background: '#ece9e2',
      tagline: function (count) { return '由入門到旗艦，' + count + ' 款掃地機器人任你揀'; },
      othersLabel: '配件與工具'
    },
    '吸塵機': {
      subtitle: 'Cordless',
      background: '#f3ede1',
      tagline: '輕巧無綫，全屋高效清潔',
      othersLabel: '配件與工具'
    },
    '洗地機': {
      subtitle: 'Wet & dry',
      background: '#eae4d8',
      tagline: '一機搞掂，邊拖邊洗',
      othersLabel: '配件與工具'
    },
    '風筒個護': {
      subtitle: 'Hair care',
      background: '#f1e8e4',
      tagline: '高速護髮，旅行造型一支搞掂',
      othersLabel: '配件與工具'
    },
    '除濕除蟎機': {
      subtitle: 'Dehumidifier / mite',
      background: '#ece9e2',
      tagline: '乾爽除蟎，健康家居',
      othersLabel: '配件與工具'
    },
    '空氣清新機': {
      subtitle: 'Air purifier',
      background: '#f3ede1',
      tagline: '寵物家庭之選，主動集毛除味',
      othersLabel: '配件與工具'
    },
    '空氣炸鍋': {
      subtitle: 'Air fryer',
      background: '#eae4d8',
      tagline: '隨時隨地開始炸',
      othersLabel: '配件與工具'
    },
    '無葉空氣循環扇': {
      subtitle: 'Bladeless fan',
      background: '#f3ede1',
      tagline: '無葉設計，安全靜音循環送風'
    },
    '門市據點': {
      subtitle: 'Store locations',
      background: '#FAFAF8',
      othersLabel: '門市與服務'
    }
  };

  // Product badges are DATA-DRIVEN (v7, 2026-08-23): product metafields
  // custom.product_tag_text + custom.product_tag_colour (emitted as tag_text /
  // tag_color in the menu JSON). A badge renders only when BOTH are filled.

  var OTHERS_META = {
    '掃拖機器人配件': { icon: '+', subtitle: 'Robot accessories' },
    '無綫吸塵器配件': { icon: '+', subtitle: 'Cordless accessories' },
    '乾濕洗地機配件': { icon: '+', subtitle: 'Wet & dry accessories' },
    '風筒配件': { icon: '+', subtitle: 'Hair dryer accessories' },
    '空氣清新機配件': { icon: '+', subtitle: 'Filter & accessories' },
    'PT60 配件': { icon: '+', subtitle: 'Air fryer accessories' },
    '自動上下水模組配件': { icon: '≡', subtitle: 'Auto water-supply module' },
    '型號比較': { icon: '#', subtitle: 'Compare models' },
    '個護產品 / 比較': { icon: '#', subtitle: 'Personal care' },
    '香港旗艦店': { subtitle: 'Hong Kong flagship' },
    '豐澤 Fortress': { subtitle: 'Fortress counters' },
    '線下零售商': { subtitle: 'Offline retailers' },
    '體驗店 Demo Store': { subtitle: 'Product demo store' },
    '澳門維修中心': { subtitle: 'Macau service centre' }
  };

  function isVisibleFocus(item) {
    return FOCUS_HIDDEN.indexOf(item.title) === -1;
  }

  function getMenuData() {
    var el = document.getElementById('ab-test-mobile-menu-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[ab-burger-menu] failed to parse #ab-test-mobile-menu-data', e);
      return null;
    }
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || cents === '') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.moneyFormat).replace(/\.00$/, '');
    }
    return 'HK$' + Math.round(cents / 100).toLocaleString('en-HK');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function setupHeaderSearchOverride() {
    if (document.querySelector('.ab-burger-header-search')) return;

    var detailsEl = document.getElementById('Details-menu-drawer-container');
    var leftIcons = document.querySelector('.header__left-icons');
    if (!detailsEl || !leftIcons) {
      console.warn('[ab-burger-menu] header override selectors not found — has the theme markup changed?');
      return;
    }

    // real search form: submits to Shopify /search (product results, prefix matching)
    var bar = document.createElement('form');
    bar.className = 'ab-burger-header-search';
    bar.action = '/search';
    bar.method = 'get';
    bar.style.display = 'none';
    bar.innerHTML =
      '<button type="submit" class="ab-burger-header-search__go" aria-label="搜尋">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 5L20.49 19l-5-5zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14z"/></svg>' +
      '</button>' +
      '<input class="ab-burger-header-search__input" type="search" name="q" placeholder="搜尋 X60 Ultra、洗地機、風筒…" aria-label="搜尋產品" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">' +
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<input type="hidden" name="type" value="product">'; // remove this line to include pages/articles in results
    bar.addEventListener('submit', function (e) {
      var q = bar.querySelector('input[name="q"]');
      if (!q || !q.value.trim()) e.preventDefault();
    });
    leftIcons.insertAdjacentElement('afterend', bar);

    var detailChrome = document.createElement('div');
    detailChrome.className = 'ab-burger-header-detail';
    detailChrome.style.display = 'none';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'ab-burger-header-back';
    backBtn.setAttribute('aria-label', '返回');
    backBtn.innerHTML = '&lsaquo;';
    backBtn.addEventListener('click', function () {
      var root = document.querySelector('.ab-burger');
      if (root) showPanel(root, 'home');
    });
    detailChrome.appendChild(backBtn);

    var titleEl = document.createElement('span');
    titleEl.className = 'ab-burger-header-title';
    detailChrome.appendChild(titleEl);

    leftIcons.insertAdjacentElement('afterend', detailChrome);

    function syncState() {
      var isOpen = detailsEl.hasAttribute('open');
      document.documentElement.classList.toggle('ab-burger-drawer-open', isOpen);
      if (isOpen) {
        var root = document.querySelector('.ab-burger');
        if (root) showPanel(root, 'home');
      } else {
        homeScrollTop = 0;
        bar.style.display = 'none';
        detailChrome.style.display = 'none';
        var summary = document.querySelector('#Details-menu-drawer-container > summary.header__icon--menu');
        if (summary) summary.style.visibility = '';
      }
    }

    detailsEl.addEventListener('toggle', syncState);
    syncState();
  }

  function panelId(prefix, title) {
    return 'ab-panel-' + prefix + '-' + title.replace(/[^a-zA-Z0-9一-鿿]+/g, '-');
  }

  var homeScrollTop = 0;

  function showPanel(root, id) {
    var current = root.querySelector('.ab-burger-panel.is-active');
    if (current && current.dataset.panelId === 'home' && id !== 'home') {
      homeScrollTop = root.scrollTop;
    }
    var panels = root.querySelectorAll('.ab-burger-panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.toggle('is-active', panels[i].dataset.panelId === id);
    }
    var top = id === 'home' ? homeScrollTop : 0;
    root.scrollTop = top;
    if (root.scrollTop !== top) {
      // the panel swap can leave a transiently shorter scroll height that clamps
      // the write; re-assert once layout has settled
      requestAnimationFrame(function () { root.scrollTop = top; });
    }
    syncHeaderChrome(root, id);
  }

  function syncHeaderChrome(root, id) {
    var menuToggleSummary = document.querySelector('#Details-menu-drawer-container > summary.header__icon--menu');
    var detailChrome = document.querySelector('.ab-burger-header-detail');
    var searchBar = document.querySelector('.ab-burger-header-search');
    var titleEl = document.querySelector('.ab-burger-header-title');
    if (!menuToggleSummary || !detailChrome || !searchBar || !titleEl) return;

    var isHome = id === 'home';
    menuToggleSummary.style.visibility = isHome ? '' : 'hidden';
    detailChrome.style.display = isHome ? 'none' : '';
    searchBar.style.display = isHome ? '' : 'none';

    if (!isHome) {
      var panel = root.querySelector('.ab-burger-panel[data-panel-id="' + id + '"]');
      titleEl.textContent = panel ? panel.dataset.title || '' : '';
    }
  }

  function buildSectionHeading(en, zh) {
    var h = document.createElement('div');
    h.className = 'ab-burger-section-heading';
    h.innerHTML =
      '<span class="ab-burger-section-heading__en">' + escapeHtml(en) + '</span> ' +
      '<span class="ab-burger-section-heading__zh">' + escapeHtml(zh) + '</span>';
    return h;
  }

  function buildHomePanel(data) {
    var panel = document.createElement('div');
    panel.className = 'ab-burger-panel is-active';
    panel.dataset.panelId = 'home';

    panel.appendChild(buildSectionHeading('FOCUS', '焦點推介'));
    var focusList = document.createElement('div');
    focusList.className = 'ab-burger-focus-list';
    (data.focus || []).filter(isVisibleFocus).forEach(function (item) {
      focusList.appendChild(buildFocusBanner(item));
    });
    panel.appendChild(focusList);

    panel.appendChild(buildSectionHeading('CATEGORIES', '選購類別'));
    var catList = document.createElement('div');
    catList.className = 'ab-burger-category-list';
    (data.categories || []).forEach(function (item) {
      catList.appendChild(buildCategoryRow(item));
    });
    panel.appendChild(catList);

    panel.appendChild(buildAccountLink());

    return panel;
  }

  function buildAccountLink() {
    var link = document.createElement('a');
    link.className = 'ab-burger-account';
    link.href = '/account/login';
    link.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<rect x="7" y="2" width="10" height="10" rx="5" stroke="currentColor" stroke-width="2"/>' +
      '<path d="M12 15.5C13.5 15.5 16 15.8333 16.5 16C17 16.1667 20.2 16.8 21 18C22 19.5 22 20 22 22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M12 15.5C10.5 15.5 8 15.8333 7.5 16C7 16.1667 3.8 16.8 3 18C2 19.5 2 20 2 22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '</svg>' +
      '<span>帳戶登入 / 註冊</span>';
    return link;
  }

  function buildFocusBanner(item) {
    var meta = FOCUS_META[item.title] || {};
    var light = meta.theme === 'light' || !meta.image;
    var direct = !!(meta.directLink && item.url && item.url !== '#');

    var card = document.createElement(direct ? 'a' : 'button');
    if (direct) {
      card.href = item.url;
    } else {
      card.type = 'button';
    }
    // no-control-menu: opts out of the theme MenuDrawer's close-on-button-click
    // binding (global.js), which otherwise closes the drawer when the script
    // runs before the theme binds (theme-embedded load order)
    card.className = 'ab-burger-focus-banner no-control-menu' + (light ? ' ab-burger-focus-banner--light' : '');

    var inner = '';
    if (meta.image) {
      inner +=
        '<span class="ab-burger-focus-banner__bg"><img src="' + meta.image + '" alt="" loading="lazy"' +
        (meta.imagePosition ? ' style="object-position:' + meta.imagePosition + '"' : '') +
        '></span>';
    } else {
      // fallback for promos not yet in FOCUS_META: gradient tile + first product thumb
      card.style.background = meta.background || 'linear-gradient(135deg,#f6efe0,#e9dcc0)';
      var thumb = item.products && item.products[0] ? item.products[0].image : '';
      if (thumb) inner += '<img class="ab-burger-focus-banner__thumb" src="' + thumb + '" alt="" loading="lazy">';
    }
    inner +=
      (meta.tag
        ? '<span class="ab-burger-focus-banner__tag" style="background:' + (meta.tagColor || '#c0392b') + ';color:' + (meta.tagTextColor || '#fff') + '">' + escapeHtml(meta.tag) + '</span>'
        : '') +
      '<span class="ab-burger-focus-banner__text">' +
      '<span class="ab-burger-focus-banner__title">' + escapeHtml(item.title) + '</span>' +
      (meta.desc ? '<span class="ab-burger-focus-banner__desc">' + escapeHtml(meta.desc) + '</span>' : '') +
      '</span>' +
      '<span class="ab-burger-focus-banner__arrow" aria-hidden="true">&rsaquo;</span>';
    card.innerHTML = inner;

    if (!direct) {
      card.addEventListener('click', function () {
        showPanel(card.closest('.ab-burger'), panelId('focus', item.title));
      });
    }
    return card;
  }

  function buildCategoryRow(item) {
    var meta = CATEGORY_META[item.title] || {};
    var thumb = item.products && item.products[0] ? item.products[0].image : '';

    // subtitle comes from the collection metafield custom.burger_menu_subtitle
    // (item.subtitle in the JSON). Empty -> the row shows the menu title only.
    var subtitleLine = '';
    if (item.subtitle) {
      subtitleLine = item.subtitle;
      if (item.product_count > 0) {
        subtitleLine += ' · ' + item.product_count + ' 款 · 由 ' + formatMoney(item.min_price);
      }
    }

    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'ab-burger-category-row no-control-menu';
    row.style.background = meta.background || '#ece7db';
    row.innerHTML =
      '<span class="ab-burger-category-row__text">' +
      '<span class="ab-burger-category-row__title">' + escapeHtml(item.title) + '</span>' +
      (subtitleLine ? '<span class="ab-burger-category-row__subtitle">' + escapeHtml(subtitleLine) + '</span>' : '') +
      '</span>' +
      (thumb ? '<img class="ab-burger-category-row__thumb" src="' + thumb + '" alt="" loading="lazy">' : '') +
      '<span class="ab-burger-category-row__arrow" aria-hidden="true">&rsaquo;</span>';
    row.addEventListener('click', function () {
      showPanel(row.closest('.ab-burger'), panelId('category', item.title));
    });
    return row;
  }

  function buildProductCard(product, parentTitle) {
    var badgeColor = /^#[0-9a-fA-F]{3,8}$/.test(product.tag_color || '') ? product.tag_color : '';
    var badge = (product.tag_text && badgeColor) ? product.tag_text : '';
    var hasCompare = product.compare_at_price && product.compare_at_price > product.price;

    var card = document.createElement('a');
    card.className = 'ab-burger-product-card';
    card.href = product.url;
    card.innerHTML =
      '<span class="ab-burger-product-card__media">' +
      (badge ? '<span class="ab-burger-product-card__badge" style="background:' + badgeColor + '">' + escapeHtml(badge) + '</span>' : '') +
      (product.image ? '<img class="ab-burger-product-card__image" src="' + product.image + '" alt="" loading="lazy">' : '') +
      '</span>' +
      '<span class="ab-burger-product-card__info">' +
      '<span class="ab-burger-product-card__title">' + escapeHtml(product.title) + '</span>' +
      '<span class="ab-burger-product-card__price">' +
      formatMoney(product.price) +
      (hasCompare ? ' <s class="ab-burger-product-card__compare">' + formatMoney(product.compare_at_price) + '</s>' : '') +
      '</span>' +
      '</span>';
    return card;
  }

  function buildOtherRow(other) {
    var meta = OTHERS_META[other.title] || {};
    var row = document.createElement('a');
    row.className = 'ab-burger-other-row';
    row.href = other.url;
    row.innerHTML =
      (meta.icon ? '<span class="ab-burger-other-row__icon">' + escapeHtml(meta.icon) + '</span>' : '') +
      '<span class="ab-burger-other-row__text">' +
      '<span class="ab-burger-other-row__title">' + escapeHtml(other.title) + '</span>' +
      (meta.subtitle ? '<span class="ab-burger-other-row__subtitle">' + escapeHtml(meta.subtitle) + '</span>' : '') +
      '</span>' +
      '<span class="ab-burger-other-row__arrow" aria-hidden="true">&rsaquo;</span>';
    return row;
  }

  function buildDetailPanel(item, kind) {
    var meta = (kind === 'focus' ? FOCUS_META[item.title] : CATEGORY_META[item.title]) || {};

    var panel = document.createElement('div');
    panel.className = 'ab-burger-panel';
    panel.dataset.panelId = panelId(kind, item.title);
    panel.dataset.title = item.title;

    if (meta.limitedDescription) {
      var limitedEl = document.createElement('p');
      limitedEl.className = 'ab-burger-detail__limited';
      limitedEl.innerHTML = meta.limitedDescription;
      panel.appendChild(limitedEl);
    }

    var tagline = typeof meta.tagline === 'function' ? meta.tagline(item.product_count || 0) : meta.tagline;
    if (tagline) {
      var taglineEl = document.createElement('p');
      taglineEl.className = 'ab-burger-detail__tagline';
      taglineEl.textContent = tagline;
      panel.appendChild(taglineEl);
    }

    if (item.products && item.products.length) {
      var grid = document.createElement('div');
      grid.className = 'ab-burger-product-grid';
      item.products.forEach(function (p) {
        grid.appendChild(buildProductCard(p, item.title));
      });
      panel.appendChild(grid);
    }

    // v6: drop rows whose url is '#' (placeholder links in the linklist)
    var others = (item.others || []).filter(function (o) { return o.url && o.url !== '#'; });
    if (others.length) {
      if (meta.othersLabel) {
        var othersHeading = document.createElement('p');
        othersHeading.className = 'ab-burger-detail__others-label';
        othersHeading.textContent = meta.othersLabel;
        panel.appendChild(othersHeading);
      }
      var othersList = document.createElement('div');
      othersList.className = 'ab-burger-others-list';
      others.forEach(function (o) {
        othersList.appendChild(buildOtherRow(o));
      });
      panel.appendChild(othersList);
    }

    if (item.url && item.url !== '#') {
      var cta = document.createElement('a');
      cta.className = 'ab-burger-detail__cta';
      cta.href = item.url;
      cta.innerHTML =
        '<span>' + escapeHtml(meta.ctaText || '查看全部') + '</span>' +
        '<span class="ab-burger-detail__cta-arrow" aria-hidden="true">&rsaquo;</span>';
      panel.appendChild(cta);
    }

    return panel;
  }

  function createNavRoot(data) {
    var root = document.createElement('div');

    root.className = 'ab-burger menu-drawer__navigation';
    root.appendChild(buildHomePanel(data));
    (data.focus || []).filter(isVisibleFocus).forEach(function (item) {
      var meta = FOCUS_META[item.title] || {};
      if (meta.directLink) return; // direct-link banners navigate straight to item.url, no panel
      root.appendChild(buildDetailPanel(item, 'focus'));
    });
    (data.categories || []).forEach(function (item) {
      root.appendChild(buildDetailPanel(item, 'category'));
    });
    return root;
  }

  function injectStyles() {
    if (document.getElementById('ab-burger-styles')) return;
    var style = document.createElement('style');
    style.id = 'ab-burger-styles';
    style.textContent =
      '.header__inner{padding: 5px .5rem;}' +
      '.ab-burger{position:relative;overflow-x:hidden;}' +
      '#menu-drawer .ab-burger.menu-drawer__navigation{padding-top:0px !important;max-height: calc(var(--viewport-height, 100dvh) - var(--header-bottom-position, 140px)) !important;overflow-y: auto !important;padding-bottom: 0px !important;border-top: 1px solid #E9E9E6;}' +
      '.ab-burger-panel{display:none;padding: 0px 16px 16px;}' +
      /* v6: detail panels get their own top padding so spacing never depends
         on a tagline existing (the "cards stuck at the top" fix) */
      '.ab-burger-panel:not([data-panel-id="home"]){padding-top:14px;}' +
      '.ab-burger-panel.is-active{display:block;}' +
      '@keyframes ab-burger-slide-in{from{transform:translateX(100%);}to{transform:translateX(0);}}' +
      '.ab-burger-panel.is-active:not([data-panel-id="home"]){animation:ab-burger-slide-in .1s ease;}' +
      '.ab-burger-section-heading{font-size:12px;letter-spacing:.05em;color:#999;margin:18px 0 10px;text-transform:uppercase;}' +
      '.ab-burger-section-heading__zh{color:#555;text-transform:none;}' +
      /* ---- FOCUS: MY-style image banners with floating tags (v5) ---- */
      '.ab-burger-focus-list{display:flex;flex-direction:column;gap:14px;margin-bottom:8px;}' +
      '.ab-burger-focus-banner{position:relative;display:block;width:100%;height:140px;border:0;border-radius:14px;padding:0;text-align:left;cursor:pointer;background:#15130f;color:#fff;text-decoration:none;box-shadow:0 2px 8px rgba(15,15,15,.16),0 1px 2px rgba(15,15,15,.1);transition:transform .16s ease;}' +
      '.ab-burger-focus-banner:active{transform:scale(.985);}' +
      '.ab-burger-focus-banner__bg{position:absolute;top:0;left:0;right:0;bottom:0;border-radius:14px;overflow:hidden;}' +
      '.ab-burger-focus-banner__bg img{display:block;width:100%;height:100%;object-fit:cover;}' +
      '.ab-burger-focus-banner__bg::after{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background:linear-gradient(to right,rgba(10,9,7,.84) 0%,rgba(10,9,7,.45) 46%,rgba(10,9,7,.02) 78%);}' +
      '.ab-burger-focus-banner__bg::before{content:"";position:absolute;top:0;left:0;right:0;height:22px;z-index:1;background:linear-gradient(to bottom,rgba(10,9,7,.6),rgba(10,9,7,0));}' +
      '.ab-burger-focus-banner--light{background:#f2f0ec;color:#0F0F0F;box-shadow:0 2px 8px rgba(15,15,15,.1),0 1px 2px rgba(15,15,15,.06);}' +
      '.ab-burger-focus-banner--light .ab-burger-focus-banner__bg::after{background:linear-gradient(to right,rgba(242,240,236,.94) 0%,rgba(242,240,236,.55) 42%,rgba(242,240,236,0) 70%);}' +
      '.ab-burger-focus-banner--light .ab-burger-focus-banner__bg::before{display:none;}' +
      '.ab-burger-focus-banner__tag{position:absolute;top:-9px;left:12px;z-index:3;font-size:10.5px;font-weight:700;letter-spacing:.02em;line-height:1;border-radius:5px;padding:5px 9px 4px;box-shadow:0 2px 6px rgba(15,15,15,.28);}' +
      '.ab-burger-focus-banner__text{position:absolute;left:16px;right:44px;top:50%;transform:translateY(-50%);z-index:2;}' +
      '.ab-burger-focus-banner__title{display:block;font-weight:700;font-size:17px;line-height:1.25;text-shadow:0 1px 5px rgba(10,9,7,.55);}' +
      '.ab-burger-focus-banner__desc{display:block;font-size:11px;margin-top:4px;opacity:.88;text-shadow:0 1px 4px rgba(10,9,7,.55);}' +
      '.ab-burger-focus-banner--light .ab-burger-focus-banner__title,.ab-burger-focus-banner--light .ab-burger-focus-banner__desc{text-shadow:none;}' +
      '.ab-burger-focus-banner__arrow{position:absolute;right:10px;top:50%;transform:translateY(-50%);z-index:2;width:26px;height:26px;border-radius:50%;background:rgba(255,255,255,.2);color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;}' +
      '.ab-burger-focus-banner--light .ab-burger-focus-banner__arrow{background:rgba(15,15,15,.08);color:#0F0F0F;}' +
      '.ab-burger-focus-banner__thumb{position:absolute;right:44px;top:50%;transform:translateY(-50%);width:84px;height:84px;object-fit:contain;z-index:1;}' +
      /* ---- categories and the rest: unchanged from the prepared script ---- */
      '.ab-burger-category-list{display:flex;flex-direction:column;gap:12px;}' +
      '.ab-burger-category-row{display:flex;align-items:center;width:100%;border:0;background:#ece7db;border-radius:14px;padding:14px 16px;text-align:left;color:#0F0F0F;}' +
      '.ab-burger-category-row__text{flex:1;}' +
      '.ab-burger-category-row__title{display:block;font-weight:700;font-size:15px;}' +
      '.ab-burger-category-row__subtitle{display:block;font-size:12px;color:#777;margin-top:2px;}' +
      '.ab-burger-category-row__thumb{width:64px;height:64px;object-fit:contain;margin:0 8px;border-radius: 10px;}' +
      '.ab-burger-category-row__arrow{font-size: 15px;opacity: .6;background: rgba(255, 255, 255, .7);color: #0F0F0F;width: 28px;height: 28px;border-radius: 50%;display: flex;align-items: center;justify-content: center;}' +
      '.ab-burger-account{display:flex;align-items:center;gap:10px;padding:16px 0;margin-top:8px;border-top:1px solid #eee;text-decoration:none;color:inherit;font-size:14px;}' +
      '.ab-burger-detail__tagline{font-size:13px;color:#888;margin:0 0 14px;}' +
      '.ab-burger-detail__limited{background:#0b0a09;color:#fff;font-size:12px;line-height:1.6;padding:14px 16px;border-radius:10px;margin:0 0 16px;}' +
      '.ab-burger-detail__limited-highlight{color:#e1d2a9;font-weight:700;}' +
      '.ab-burger-detail__others-label{font-size:12px;color:#999;margin:16px 0 8px;}' +
      '.ab-burger-product-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}' +
      '.ab-burger-product-card{position:relative;display:block;border-radius:12px;overflow:hidden;background:#fff;text-decoration:none;color:inherit;border: 1px solid #e9e9e6;}' +
      '.ab-burger-product-card__media{position:relative;display:block;background:#f4f4f4;padding:12px;aspect-ratio: 1;}' +
      '.ab-burger-product-card__badge{position:absolute;top:8px;left:8px;color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:3px;z-index: 1;}' +
      '.ab-burger-product-card__image{display:block;width:100%;height:100%;object-fit:contain;mix-blend-mode: multiply;}' +
      '.ab-burger-product-card__info{display:block;padding:8px 12px 12px;}' +
      '.ab-burger-product-card__title{display:block;font-size:12px;margin-bottom:4px;}' +
      ".ab-burger-product-card__price{display:block;font-size:13px;font-weight:700;font-family: 'JudgemeStar';}" +
      '.ab-burger-product-card__compare{font-weight:400;color:#999;margin-left:4px;font-size: 10px;}' +
      '.ab-burger-others-list{display:flex;flex-direction:column;gap:8px;}' +
      /* v6: keep a gap above the others rows even when the label is missing */
      '.ab-burger-product-grid + .ab-burger-others-list{margin-top:14px;}' +
      '.ab-burger-other-row{display:flex;align-items:center;gap:12px;padding:12px 14px;background:#fafaf8;border-radius:10px;text-decoration:none;color:inherit;font-size:13px;border: 1px solid #e9e9e6;}' +
      '.ab-burger-other-row__icon{flex:0 0 auto;width:32px;height:32px;border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center;font-size:16px;color:#a0743e;border:1px solid #e9e9e6;}' +
      '.ab-burger-other-row__text{flex:1;min-width:0;display:flex;flex-direction:column;}' +
      ".ab-burger-other-row__title{font-family: 'MisansTC';font-size:13px;}" +
      '.ab-burger-other-row__subtitle{font-size:10.5px;color:#6b7280;}' +
      '.ab-burger-other-row__arrow{flex:0 0 auto;opacity:.6;}' +
      '.ab-burger-detail__cta{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:20px;padding:14px;background:#111;color:#fff;border-radius:10px;text-decoration:none;font-size:13.5px;}' +
      '.ab-burger-detail__cta-arrow{font-size:16px;line-height:1;}' +
      '.ab-burger-header-search{display:flex;align-items:center;gap:8px;grid-row:1;grid-column:2;justify-self:stretch;min-width:59vw;margin:0 8px;padding:7px 14px;border-radius:20px;background:#f2f2f2;border:0;color:#888;}' +
      '.ab-burger-header-search__go{flex:0 0 auto;display:flex;align-items:center;border:0;background:none;padding:0;color:#888;cursor:pointer;}' +
      /* input stays at 16px: iOS Safari auto-zooms the viewport on focus for anything smaller */
      '.ab-burger-header-search__input{flex:1;min-width:0;border:0;background:none;padding:0;font-size:16px;line-height:1.3;color:#111;outline:none;-webkit-appearance:none;appearance:none;}' +
      '.ab-burger-header-search__input::placeholder{color:#999;font-size:13px;}' +
      '.ab-burger-header-search__input::-webkit-search-cancel-button{-webkit-appearance:none;}' +
      '.header__inner{position:relative;}' +
      '.ab-burger-header-detail{position:absolute;left:0;top:50%;transform:translateY(-50%);z-index:1;display:flex;align-items:center;gap:8px;}' +
      '.ab-burger-header-back{border:0;background:none;font-size:26px;line-height:1;padding:0 8px;color:inherit;flex:0 0 auto;}' +
      '.ab-burger-header-title{font-weight:700;font-size:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
      'html.ab-burger-drawer-open .header__heading{display:none !important;}' +
      'html.ab-burger-drawer-open .header__icon--account{display:none !important;}' +
      'html.ab-burger-drawer-open .header__search{display:none !important;}' +
      '@media (max-width: ' + MOBILE_MAX_WIDTH + 'px) {' +
      '#menu-drawer.menu-drawer.menu-drawer{width:100% !important;}' +
      '}';
    document.head.appendChild(style);
  }

  function init() {
    if (window.matchMedia('(min-width: ' + (MOBILE_MAX_WIDTH + 1) + 'px)').matches) return;

    var data = getMenuData();
    if (!data) return;

    var target = document.querySelector('#menu-drawer .menu-drawer__navigation-container');
    if (!target) {
      console.warn('[ab-burger-menu] .menu-drawer__navigation-container not found — has the theme markup changed?');
      return;
    }
    if (target.querySelector('.ab-burger')) return; // idempotent: Varify may re-run on soft navigation

    injectStyles();
    target.innerHTML = '';
    target.appendChild(createNavRoot(data));
    setupHeaderSearchOverride();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
